import { render } from "./TermReq.vue?vue&type=template&id=e3f5983a"
import script from "./TermReq.vue?vue&type=script&lang=js"
export * from "./TermReq.vue?vue&type=script&lang=js"

import "./TermReq.vue?vue&type=style&index=0&id=e3f5983a&lang=css"

import exportComponent from "C:\\Users\\surface\\3D Objects\\Work\\schools\\inspire-school\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__